// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { IApplicationState } from "../../models/applicationState";

/**
 * Initial state of application
 * @member appSettings - Application settings
 * @member connections - Connections
 * @member loadAllFiles - Recent projects
 * @member recentProjects - Recent projects
 * @member currentProject - Current project
 */
const initialState: IApplicationState = {
    appSettings: {
        securityTokens: [],
    },
    connections: [],
    loadAllFiles: [],
    loadTestFiles: [],
    loadModels: [],
    loggedInUser: null,
    userQueues: [],
    uploadFilesCount: null,
    // userValidations: [],
    // userTransformations: [],
    recentProjects: [],
    selectedOcrFiles: [],
    currentProject: null,
    appError: null,
    logOutUser: null,
    loadOPTestFiles: [],
};

/**
 * Instance of initial application state
 */
export default initialState;
